// extracted by mini-css-extract-plugin
export default {"cardData":"priceData_cardData__s0J8n"};